import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/components/Landing";
import BlueprintView from "@/components/BlueprintView";
import PublishWizard from "@/components/PublishWizard";
import PublishHome from "@/components/PublishHome";
import Studio from "@/components/Studio";
import Discovery from "@/components/Discovery";
import Auth from "@/components/Auth";
import GoogleCallback from "@/components/GoogleCallback";
import Account from "@/components/Account";
import Admin from "@/components/Admin";
import Help from "@/components/Help";
import HelpWidget from "@/components/HelpWidget";
import TicketInbox from "@/components/TicketInbox";
import Teams from "@/components/Teams";
import StatusPage from "@/components/StatusPage";
import { OSProvider } from "@/modules/os/OSContext";
import OSShell from "@/modules/os/OSShell";
import ExecutiveDashboard from "@/modules/os/dashboard/ExecutiveDashboard";
import AskArca from "@/modules/os/ask/AskArca";
import NotificationSettings from "@/modules/os/NotificationSettings";
import PromptLibrary from "@/modules/os/prompts/PromptLibrary";
import PromptDetail from "@/modules/os/prompts/PromptDetail";
import { OSMembers, OSActivity, OSPlaceholder } from "@/modules/os/pages";
import CatalogList from "@/modules/os/catalog/CatalogList";
import ProductDetail from "@/modules/os/catalog/ProductDetail";
import AttentionCenter from "@/modules/os/attention/AttentionCenter";
import { EntityList, EntityDetail } from "@/modules/os/EntityModule";
import DailyBrief from "@/modules/os/DailyBrief";

function App() {
  return (
    <div className="App bg-[#050505]">
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/b/:slug" element={<BlueprintView />} />
            <Route path="/publish" element={<PublishHome />} />
            <Route path="/publish/:projectId" element={<PublishWizard />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/studio/discovery/:sessionId" element={<Discovery />} />
            <Route path="/studio/:projectId" element={<Studio />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/auth/google" element={<GoogleCallback />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/tickets" element={<TicketInbox />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/teams/join/:token" element={<Teams />} />
            <Route path="/teams/:teamId" element={<Teams />} />
            <Route path="/help" element={<Help />} />
            <Route path="/help/:slug" element={<Help />} />
            <Route path="/status/:slug" element={<StatusPage />} />
            <Route path="/os" element={<OSProvider><OSShell /></OSProvider>}>
              <Route index element={<ExecutiveDashboard />} />
              <Route path="ask" element={<AskArca />} />
              <Route path="notifications" element={<NotificationSettings />} />
              <Route path="attention" element={<AttentionCenter />} />
              <Route path="brief" element={<DailyBrief />} />
              <Route path="catalog" element={<CatalogList />} />
              <Route path="catalog/:id" element={<ProductDetail />} />
              <Route path="projects" element={<EntityList moduleKey="projects" />} />
              <Route path="projects/:id" element={<EntityDetail moduleKey="projects" />} />
              <Route path="bible" element={<EntityList moduleKey="bible" />} />
              <Route path="bible/:id" element={<EntityDetail moduleKey="bible" />} />
              <Route path="business-brief" element={<EntityList moduleKey="business-brief" />} />
              <Route path="business-brief/:id" element={<EntityDetail moduleKey="business-brief" />} />
              <Route path="decisions" element={<EntityList moduleKey="decisions" />} />
              <Route path="decisions/:id" element={<EntityDetail moduleKey="decisions" />} />
              <Route path="roadmap" element={<EntityList moduleKey="roadmap" />} />
              <Route path="roadmap/:id" element={<EntityDetail moduleKey="roadmap" />} />
              <Route path="milestones" element={<EntityList moduleKey="milestones" />} />
              <Route path="milestones/:id" element={<EntityDetail moduleKey="milestones" />} />
              <Route path="search" element={<OSPlaceholder title="Search" />} />
              <Route path="prompts" element={<PromptLibrary />} />
              <Route path="prompts/:id" element={<PromptDetail />} />
              <Route path="members" element={<OSMembers />} />
              <Route path="activity" element={<OSActivity />} />
            </Route>
          </Routes>
          <HelpWidget />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
